@if (slides()) {
    <div
        class="surface-bets-container"
        data-crlat="surfaceBetsCarousel"
        [ngClass]="{ 'homepage-sfb-v2design': isV2Design }"
        [elemEventType]="'touchmove'"
        [scrollonce]="'surfaceBet'"
        [GATrackingObj]="GATrackingObj">
        <div
            class="ng-carousel surface-bets-carousel"
            [class.one-card-mode]="isOneCard"
            [ngCarousel]
            ngCarouselExtended
            [ngCarouselWatch]="slides()"
            [ngCarouselName]="carouselName"
            [ngCarouselFluid]="true"
            [ngCarouselLoop]="false"
            [ngCarouselMoveThresholdPercentage]="5"
            [optionalTransform]="5"
            (slidedSide)="fetchSurfaceBetsData($event)">
            <slidecontainer class="carousel-slides">
                @for (betData of surfaceBetsData; let betInd = $index; track '$' + betInd + '_$' + betData.id) {
                    @if (betData.markets.length) {
                        <slide class="slide">
                            <odds-card-surface-bet
                                (sBreactionsLoaded)="sbReactionsLoaded()"
                                [surfaceBet]="betData"
                                [surfaceBetIndex]="betInd + 1"
                                [isEdp]="isEdp"
                                [hubIndex]="hubIndex"
                                [sportId]="sportId"
                                [sportName]="sportName"
                                [sbReactionConfig]="showReactions && sbReactionConfig"
                                [singleReactionCount]="
                                    showReactions && reactionData && reactionData.reactions[betData.objId]
                                "></odds-card-surface-bet>
                        </slide>
                    }
                }
            </slidecontainer>
        </div>
    </div>
}
